import React from "react";
import EvaluationInProgress from "../Components/EvaluationPage/EvaluationInProgress";

const EvaluationInProgressPage: React.FC = () => {
  return (
    <div>
      <EvaluationInProgress />
    </div>
  );
};

export default EvaluationInProgressPage;
